import $ from 'jquery';
import '../lib/swiper.min.js';
import '../scss/swiper.scss';
import './fullpage';
import './article';
import './game';
import './fb';
import '../img/swiper/news-default.jpg';
import { initSwiper } from './swiper';
import { initGameInfo } from "./download";
import * as report from './dataReport';
export const state = {
  music: true,
};
export const init = async () => {
  $('.j-copyright').on('click', () => {
    $('.j-footer').toggleClass('active');
  });
  $('.j-close,.j-mask').on('click', function () {
    $('.j-popup').fadeOut(500);
  });
  $('.j-wrap-btn').on('click', () => {
    $('.j-aside').toggleClass('active');
  });
  $('.j-menu-top-hide').on('click', () => {
    $('.j-top-list').hide(600).removeClass('active');
    $('.j-menu-top').show(200);
  });
  $('.j-menu-top').on('click', () => {
    $('.j-menu-top').hide(200);
    $('.j-top-list').show(600).addClass('active');
  });
  $('.j-menu-social').on('click', () => {
    $('.j-menu-social').hide(200);
    $('.j-social-list').show(600);
  });
  $('.j-menu-social-hide').on('click', () => {
    $('.j-social-list').hide(600);
    $('.j-menu-social').show(200);
  });
  $('.j-social').on('click', () => {
    $('.j-social-popup').fadeIn(500);
  });
  $('.j-game').on('click', () => {
    $('.j-game-popup').fadeIn(500);
  });
  $('.j-audio-icon').on('click', ({ currentTarget }) => {
    $(currentTarget).toggleClass('pause');
    state.music = !state.music;
    state.music
      ? $('.j-music-audio')[0].play()
      : $('.j-music-audio')[0].pause();
  });
  $('.j-youtube-video').on('click', ({ currentTarget }) => {
    const videoId = currentTarget.dataset.id;
    if (!videoId.length) return;
    $('.j-video-wrapper').html(
      `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${videoId}?rel=0&playsinline=1&showinfo=0&disablekb=1&autoplay=1&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    );
    state.music && $('.j-music-audio')[0].pause();
    $('.j-video-popup').fadeIn(500);
  });
  $('.j-video-close').on('click', () => {
    $('.j-video-wrapper').html('');
    !$('.j-audio-icon').hasClass('pause') && $('.j-music-audio')[0].play();
  });
  initSwiper();
  report.initReport();
  await initGameInfo();
};

